<template>
	<c-dialog ref="dialog" width="1000" height="560" enable-flex>
		<!-- 控价预警结果：仅提醒模式下破价记录已正常提交，此处只做告知，不做拦截 -->
		<div class="m-result-summary flex">
			<p class="flex-grow">
				<span class="m-count-warn">{{warnCount}}条售价低于最低控价</span>
			</p>
			<p v-if="warnCount > warnList.length" class="m-count-limit">仅展示前{{warnList.length}}条</p>
		</div>

		<div class="m-result-table-area flex-column flex-grow">
			<c-table ref="list" :data="warnList" height="grow" :paging="false" empty-text="没有低于最低控价的记录">
				<c-table-column label="背贴码" name="produce_unique_code" width="120"></c-table-column>
				<c-table-column label="渠道" min-width="150">
					<template #default="{data}">{{data.channel_name || '全部渠道'}}</template>
				</c-table-column>
				<c-table-column label="提交售价" width="120">
					<template #default="{data}"><span class="m-price-below">{{formatPrice(data.sale_price)}}</span></template>
				</c-table-column>
				<c-table-column label="最低控价" width="120">
					<template #default="{data}">{{formatPrice(data.min_price)}}</template>
				</c-table-column>
				<c-table-column label="低于控价" width="120">
					<template #default="{data}">{{formatPrice(data.diff_amount)}}</template>
				</c-table-column>
			</c-table>
		</div>
        
		<template #button>
			<c-button size="dialog" color="main" @click="$refs.dialog.close()">知道了</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'salePriceWarnResult',

		data() {
			return {
				/**后端返回的破价总条数，可能大于已回传明细数（受回传上限约束）*/
				warnCount: 0,
				warnList: []
			}
		},

		methods: {
			/*********打开弹框（只读结果页，入参为上架/改价接口返回的统计对象）**********/
			open(data) {
				var result = data || {};
				this.warnCount = result.price_warn_count || 0;
				this.warnList = result.price_warn_list || [];
				this.$refs.dialog.open({
					title: '控价提醒'
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	::v-deep .c-dialog-body {
		padding: 0 12px;
	}

	.m-result-summary {
		padding: 12px 15px;
		margin-bottom: 12px;
		background: #f5f7fa;
		border-radius: 4px;
		font-size: 14px;
		gap: 12px;

		.m-count-warn {
			color: #e6a23c;
		}

		.m-count-limit {
			color: #909399;
			font-size: 13px;
		}
	}

	.m-result-table-area {
		margin: 0 20px 10px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;

		.m-price-below {
			color: #ed3f14;
			font-weight: bold;
		}
	}

	.m-result-tip {
		padding: 0 20px 12px;
		font-size: 13px;
		color: #909399;
	}
</style>
